import { Pipe, PipeTransform } from '@angular/core';
import { Users } from '../models/users';

@Pipe({
  name: 'userFilter'
})
export class UserFilterPipe implements PipeTransform {

  transform(users: Users[], filterText: string): unknown {
    if (!users) return users;
    if (users.length === 0 || filterText === "") {
      return users;
    } else {
      return users.filter((user) => {
        return user.userName.toLowerCase().includes(filterText.toLowerCase());
      })
    }
  }

}
